import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";
const FooterOfRaportWakel = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            RW_rasedyKotaye$,
            RW_rasedyKotayeID,
            RW_koyfroshtndianr,
            RW_koyfroshtndolar,
            Rw_koyparaydrawbaID,
            Rw_koyparaydrawba$,
            RW_koyGaranawadianr,
            RW_koyGaranawadolar,
            RW_koyDashkanDolar,
            RW_koyDashkanDinar
          } = value;
          return (
            <>
              {/* second row */}
              <br />
              <div className="row">
                <div className="col-2">
                  <h4 className="text-warning tc ">کۆی فرۆشتن</h4>
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyfroshtndolar))
                          ? Number(RW_koyfroshtndolar)
                          : Number(RW_koyfroshtndolar).toFixed(2)
                      }
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h4 className="text-warning tc ">پارەی دراو</h4>
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(Rw_koyparaydrawba$))
                          ? Number(Rw_koyparaydrawba$)
                          : Number(Rw_koyparaydrawba$).toFixed(2)
                      }
                      prefix={"$"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h4 className="text-warning tc ">پارەی گەڕانەوە</h4>
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyGaranawadolar))
                          ? Number(RW_koyGaranawadolar)
                          : Number(RW_koyGaranawadolar).toFixed(2)
                      }
                      prefix={"$"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h4 className="text-warning tc ">کۆی داشکان</h4>
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyDashkanDolar))
                          ? Number(RW_koyDashkanDolar)
                          : Number(RW_koyDashkanDolar).toFixed(2)
                      }
                      prefix={"$"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h4 className="text-warning tc ">قەرزی کۆتایی</h4>
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_rasedyKotaye$))
                          ? Number(RW_rasedyKotaye$)
                          : Number(RW_rasedyKotaye$).toFixed(2)
                      }
                      prefix={"$"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>

                <div className="col-2"></div>
              </div>
              <div className="row">
                <div className="col-2">
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyfroshtndianr))
                          ? Number(RW_koyfroshtndianr)
                          : Number(RW_koyfroshtndianr).toFixed(2)
                      }
                      className=" f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(Rw_koyparaydrawbaID))
                          ? Number(Rw_koyparaydrawbaID)
                          : Number(Rw_koyparaydrawbaID).toFixed(2)
                      }
                      prefix={"ID"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyGaranawadianr))
                          ? Number(RW_koyGaranawadianr)
                          : Number(RW_koyGaranawadianr).toFixed(2)
                      }
                      prefix={"ID"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_koyDashkanDinar))
                          ? Number(RW_koyDashkanDinar)
                          : Number(RW_koyDashkanDinar).toFixed(2)
                      }
                      prefix={"ID"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>
                <div className="col-2">
                  <h3 className="bg-white tc">
                    <NumberFormat
                      value={
                        Number.isInteger(Number(RW_rasedyKotayeID))
                          ? Number(RW_rasedyKotayeID)
                          : Number(RW_rasedyKotayeID).toFixed(2)
                      }
                      prefix={"ID"}
                      className="bg-white f4 font-weight-bold  tc border-0"
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </h3>
                </div>

                <div className="col-2"></div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRaportWakel;
